import React, { createContext, useContext, useState } from "react";
import { PreQualifierModal } from "@/components/PreQualifier";

const Ctx = createContext(null);

export function PreQualifierProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <Ctx.Provider value={{ open: () => setOpen(true), close: () => setOpen(false), isOpen: open }}>
      {children}
      <PreQualifierModal open={open} onOpenChange={setOpen} />
    </Ctx.Provider>
  );
}
export const usePreQualifier = () => useContext(Ctx);
